import React from 'react';
const tomes = [{
  label: 'Tomo 01',
  sublabel: 'Encuadre y Admisión',
  image: 'https://cdn.magicpatterns.com/uploads/1AuUn4dco1P6vxBkxA2G1W/hf_20260420_231501_3cf9079f-b0dd-4c8f-b2b0-8ab6848fec53_(1)-Photoroom.webp'
}, {
  label: 'Tomo 02',
  sublabel: 'Plan Maestro Anual',
  image: 'https://cdn.magicpatterns.com/uploads/1AuUn4dco1P6vxBkxA2G1W/hf_20260420_231501_3cf9079f-b0dd-4c8f-b2b0-8ab6848fec53_(1)-Photoroom.webp'
}, {
  label: 'Tomo 03',
  sublabel: 'Maletín de Intervenciones',
  image: 'https://cdn.magicpatterns.com/uploads/1AuUn4dco1P6vxBkxA2G1W/hf_20260420_231501_3cf9079f-b0dd-4c8f-b2b0-8ab6848fec53_(1)-Photoroom.webp'
}, {
  label: 'Tomo 04',
  sublabel: 'Alta Complejidad',
  image: 'https://cdn.magicpatterns.com/uploads/1AuUn4dco1P6vxBkxA2G1W/hf_20260420_231501_3cf9079f-b0dd-4c8f-b2b0-8ab6848fec53_(1)-Photoroom.webp'
}, {
  label: 'Tomo 05',
  sublabel: 'Gestión y Autocuidado',
  image: 'https://cdn.magicpatterns.com/uploads/1AuUn4dco1P6vxBkxA2G1W/hf_20260420_231501_3cf9079f-b0dd-4c8f-b2b0-8ab6848fec53_(1)-Photoroom.webp'
}, {
  label: 'Tomo 06',
  sublabel: 'Consultorio Expandido',
  image: 'https://cdn.magicpatterns.com/uploads/1AuUn4dco1P6vxBkxA2G1W/hf_20260420_231501_3cf9079f-b0dd-4c8f-b2b0-8ab6848fec53_(1)-Photoroom.webp'
}];
const features = ['✅ Criterio clínico profesional en cada sesión', '✅ +360 páginas listas para implementar hoy', '✅ Scripts, plantillas y checklists imprimibles', '✅ Adaptado 100% al psicólogo argentino'];
export function ProductShowcase() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(245,243,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-256">
      <div className="mx-auto max-w-4xl text-center" data-id="element-257">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-violet-700 border border-violet-500/50 bg-violet-500/5 rounded-full px-4 py-1.5" data-id="element-258">
          🏆 El sistema clínico más completo para psicólogos en Argentina
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-violet-700 m-0 mb-4" data-id="element-259">
          MEGAPACK PSICOLOGÍA RENTABLE
        </h3>

        {/* Description */}
        <p className="max-w-2xl text-gray-800 m-0 mb-8 text-[14px]" data-id="element-260">
          <strong data-id="element-261">6 Tomos + 6 Bonos — Consultorio completo resuelto.</strong>
          <br data-id="element-262" />
          +360 páginas · Protocolo de admisión · Plan maestro anual ·
          Maletín de intervenciones · Gestión operativa · Scripts clínicos ·
          Honorarios · Autocuidado. Funciona desde hoy.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-263">
          <div className="grid grid-cols-6 gap-3" data-id="element-264">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-265">
                {/* Card con imagen real */}
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-gray-100" data-id="element-266">
                  <img src={tome.image} alt={`${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-267" />
                </div>

                {/* Título separado abajo */}
                <div className="text-center" data-id="element-268">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-269">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-270">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-271">
            <div className="whitespace-nowrap bg-violet-700 text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" data-id="element-272">
              6 TOMOS COMPLETOS · +360 PÁGINAS · ACCESO INMEDIATO
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-273">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 bg-violet-500/5 border border-violet-500/20 rounded-xl px-4 py-3 text-left" data-id="element-274">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-violet-500/15 flex items-center justify-center" data-id="element-275">
                <svg className="w-3 h-3 text-violet-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-276">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-277" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-278">
                {feature.replace('✅ ', '')}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}